<template>
  <div>
    <div class="screen">
      <p :class="{ activeClass: isYw }" @click="hanldScreenChange('yw')">
        药物<span class="iconfont icon-xiasanjiao"></span>
      </p>
      <p :class="{ activeClass: isGene }" @click="hanldScreenChange('gene')">
        基因<span class="iconfont icon-xiasanjiao"></span>
      </p>
      <van-popover
        v-model="classShowPopover"
        trigger="click"
        placement="bottom"
        :close-on-click-action="false"
        :close-on-click-outside="false"
      >
        <div class="poplist classpop">
          <p
            :class="{ isPopclass: index == activeIndex }"
            v-for="(item, index) in classPopList"
            :key="index"
            @click="handlePopClick(item, index)"
          >
            {{ item.title }}
          </p>
        </div>
        <template #reference>
          <p
            :class="{ activeClass: isClass }"
            @click="hanldScreenChange('class')"
          >
            类别<span class="iconfont icon-xiasanjiao"></span>
          </p>
        </template>
      </van-popover>

      <van-popover
        v-model="showPopover"
        trigger="click"
        placement="bottom-end"
        :close-on-click-action="false"
        :close-on-click-outside="false"
      >
        <div class="poplist">
          <p
            :class="{ isPopclass: index == activeIndex }"
            v-for="(item, index) in popList"
            :key="index"
            @click="handlePopClick(item, index ,'zj')"
          >
            {{ item.title }}
          </p>
        </div>
        <template #reference>
          <p :class="{ activeClass: isZj }" @click="hanldScreenChange('zj')">
            {{zjText}}<span class="iconfont icon-xiasanjiao"></span>
          </p>
        </template>
      </van-popover>
    </div>
    <!-- 基因筛选 -->
    <van-popup
      v-model="geneShow"
      round
      @click-close-icon="handleClose"
      position="bottom"
      :close-on-click-overlay="false"
      closeable
      close-icon="cross"
      :style="{ height: '92%' }"
    >
      <div class="yw-pop">
        <van-search
          v-model="geneValue"
          shape="round"
          placeholder="请输入搜索关键词"
          @search="onSearch"
        />
        <div class="list">
          <h1>高频基因</h1>
          <div class="checkList geneList" v-if="geneList != ''">
            <van-checkbox-group
              @change="hanldeCheck"
              direction="horizontal"
              v-model="result"
            >
              <van-checkbox
                :name="item.data"
                v-for="(item, index) in geneList"
                :key="index"
                :class="{ activeCheck: item.checked }"
              >
                <template #icon="props">
                  <span
                    class="gene_span"
                    :class="{ activeCheck: props.checked }"
                    >{{ item.data }}</span
                  >
                </template>
              </van-checkbox>
            </van-checkbox-group>
            <div class="btn">
              <button @click="Reset">重置</button>
              <button @click="ywSuccess">确定</button>
            </div>
          </div>
          <van-empty v-else description="暂无搜索内容" />
        </div>
      </div>
    </van-popup>
    <!--药物筛选  -->
    <van-popup
      v-model="ywShow"
      round
      @click-close-icon="handleClose"
      position="bottom"
      :close-on-click-overlay="false"
      closeable
      close-icon="cross"
      :style="{ height: '92%' }"
    >
      <div class="yw-pop">
        <van-search
          v-model="ywValue"
          shape="round"
          @search="onSearch"
          placeholder="请输入搜索关键词"
        />
        <div class="list">
          <h1>药物</h1>
          <div class="checkList" v-if="ywList != ''">
            <van-checkbox-group @change="hanldeCheck" v-model="result">
              <p class="_p">
                <van-checkbox
                  :name="item.data"
                  v-for="(item, index) in ywList"
                  :key="index"
                  :class="{ activeCheck: item.checked }"
                >
                  <template #icon="props">
                    <i :class="{ icon: props.checked }"></i>
                    <span
                      class="_span"
                      :class="{ activeCheck: props.checked }"
                      >{{ item.data }}</span
                    >
                  </template>
                </van-checkbox>
              </p>
            </van-checkbox-group>
            <div class="btn">
              <button @click="Reset">重置</button>
              <button @click="ywSuccess">确定</button>
            </div>
          </div>
          <van-empty v-else description="暂无搜索内容" />
        </div>
      </div>
    </van-popup>
  </div>
</template>
<script>
import { handleSearch } from "@/utils/search";
export default {
  data() {
    return {
      zjText:"证据等级",
      result: [],
      geneValue: "",
      geneAllData: [
        {
          data: "EGFR",
        },
        {
          data: "CYP2D6",
        },
        {
          data: "EGFR",
        },
        {
          data: "CYP2D6",
        },
        {
          data: "EGFR",
        },
        {
          data: "ALK",
        },
        {
          data: "EGFR",
        },
        {
          data: "CYP2D6",
        },
        {
          data: "EGFR",
        },
        {
          data: "CYP2D6",
        },
        {
          data: "EGFR",
        },
        {
          data: "ALK",
        },
      ],
      geneList: [
        {
          data: "EGFR",
        },
        {
          data: "CYP2D6",
        },
        {
          data: "EGFR",
        },
        {
          data: "CYP2D6",
        },
        {
          data: "EGFR",
        },
        {
          data: "ALK",
        },
        {
          data: "EGFR",
        },
        {
          data: "CYP2D6",
        },
        {
          data: "EGFR",
        },
        {
          data: "CYP2D6",
        },
        {
          data: "EGFR",
        },
        {
          data: "ALK",
        },
      ],
      ywAllData: [
        {
          data: "Fluoropyrimidine-based chemotherapy1",
        },
        {
          data: "Fluoropyrimidine-based chemotherapy2",
        },
        {
          data: "Fluoropyrimidine-based chemotherapy3",
        },
        {
          data: "Fluoropyrimidine-based chemotherapy1",
        },
        {
          data: "Fluoropyrimidine-based chemotherapy2",
        },
        {
          data: "Fluoropyrimidine-based chemotherapy3",
        },
        {
          data: "Fluoropyrimidine-based chemotherapy1",
        },
        {
          data: "Fluoropyrimidine-based chemotherapy2",
        },
        {
          data: "Fluoropyrimidine-based chemotherapy3",
        },
        {
          data: "Fluoropyrimidine-based chemotherapy1",
        },
        {
          data: "Fluoropyrimidine-based chemotherapy2",
        },
        {
          data: "Fluoropyrimidine-based chemotherapy3",
        },
        {
          data: "Fluoropyrimidine-based chemotherapy1",
        },
        {
          data: "Fluoropyrimidine-based chemotherapy2",
        },
        {
          data: "Fluoropyrimidine-based chemotherapy3",
        },
      ],
      ywList: [
        {
          data: "Fluoropyrimidine-based chemotherapy1",
        },
        {
          data: "Fluoropyrimidine-based chemotherapy2",
        },
        {
          data: "Fluoropyrimidine-based chemotherapy3",
        },
        {
          data: "Fluoropyrimidine-based chemotherapy1",
        },
        {
          data: "Fluoropyrimidine-based chemotherapy2",
        },
        {
          data: "Fluoropyrimidine-based chemotherapy3",
        },
        {
          data: "Fluoropyrimidine-based chemotherapy1",
        },
        {
          data: "Fluoropyrimidine-based chemotherapy2",
        },
        {
          data: "Fluoropyrimidine-based chemotherapy3",
        },
        {
          data: "Fluoropyrimidine-based chemotherapy1",
        },
        {
          data: "Fluoropyrimidine-based chemotherapy2",
        },
        {
          data: "Fluoropyrimidine-based chemotherapy3",
        },
        {
          data: "Fluoropyrimidine-based chemotherapy1",
        },
        {
          data: "Fluoropyrimidine-based chemotherapy2",
        },
        {
          data: "Fluoropyrimidine-based chemotherapy3",
        },
      ],
      ywValue: "",
      ywShow: false,
      geneShow: false,
      classShowPopover: false,
      activeIndex: Number,
      classPopList: [
        {
          title: "全部类别",
        },
        {
          title: "药物毒副作用/有效性",
        },
        {
          title: "药物毒副作用",
        },
        {
          title: "药物有效性",
        },
      ],
      popList: [
        {
          title: "全部等级",
        },
        {
          title: "Level 1A",
        },
        {
          title: "Level 1B",
        },
        {
          title: "Level 2A",
        },
        {
          title: "Level 2B",
        },
      ],
      isYw: false,
      isGene: false,
      isClass: false,
      isZj: false,
      showPopover: false,
    };
  },
  watch: {
    geneValue: function (val) {
      if (!val) {
        this.geneList = this.geneAllData;
        
      }
    },
    ywValue: function (val) {
      if (!val) {
        this.ywList = this.ywAllData
      }
    },
  },
  methods: {
    /**搜索事件 */
    onSearch(val) {
      if (val) {
        this.geneList = handleSearch(this.geneValue, this.geneList);
        this.ywList = handleSearch(this.ywValue, this.ywList);
        
      }
    },
    ywSuccess() {
      console.log(this.result);
    },
    Reset() {
      this.result = [];
    },
    hanldeCheck(val) {
      console.log(this.result);
    },
    handleClose(e) {
      console.log(e);
      this.isYw = false;
      this.isGene = false;
    },
    handlePopClick(item, index,type) {
      console.log(index);
      this.activeIndex = index;
      if(type == 'zj'){
        this.zjText = item.title
      }
    },
    hanldScreenChange(type) {
      switch (type) {
        case "yw":
          this.isYw = !this.isYw;
          this.ywShow = true;
          // this.isGene = false
          // this.isZj = false
          // this.isClass = false
          break;
        case "gene":
          this.isGene = !this.isGene;
          this.geneShow = true;
          // this.isYw = false
          // this.isZj = false
          // this.isClass = false
          break;
        case "class":
          this.isClass = !this.isClass;
          // this.isYw = false
          // this.isGene = false
          // this.isZj = false
          break;
        case "zj":
          this.isZj = !this.isZj;
          // this.isYw = false
          // this.isGene = false
          // this.isClass = false
          break;
      }
    },
  },
};
</script>
<style lang="less" scoped>
.yw-pop {
  font-family: @family;
  padding: 46px 24px;
  height: 100%;
  box-sizing: border-box;
  /deep/.van-search {
    padding: 0;
  }
  .list {
    .geneList {
      /deep/.van-checkbox-group--horizontal {
        justify-content: space-between;
        .van-checkbox--horizontal {
          margin-right: 0;
          .van-checkbox__icon {
            height: auto;
            margin-bottom: 10px;
          }
        }
      }
    }
    .checkList {
      padding: 20px 0 60px;
      height: 480px;
      overflow-y: scroll;
      box-sizing: border-box;
      .gene_span {
        width: 98px;
        height: 36px;
        background: #f8f9fb;
        border-radius: 6px;
        display: inline-block;
        font-size: 12px;
        font-weight: 400;
        color: #2f354d;
        line-height: 36px;
        text-align: center;
      }
      &::-webkit-scrollbar {
        display: none;
      }
      .btn {
        position: fixed;
        bottom: 20px;
        display: flex;
        justify-content: space-between;
        button {
          font-size: 15PX;
          font-weight: 400;
          line-height: 22px;
          letter-spacing: 1px;
          border: 0;
          &:first-child {
            width: 101px;
            height: 44px;
            background: #ffffff;
            box-shadow: 0px 6px 20px -2px rgba(52, 68, 132, 0.15);
            border-radius: 22px;
            color: #5f697d;
          }
          &:last-child {
            width: 204px;
            margin-left: 20px;
            height: 44px;
            background: linear-gradient(90deg, #6f9cff 0%, #4b84ff 100%);
            box-shadow: 0px 6px 20px -2px rgba(75, 132, 255, 0.3);
            border-radius: 22px;
            color: #ffffff;
          }
        }
      }
      .activeCheck {
        color: #4b84ff;
      }
      ._p {
        /deep/.van-checkbox {
          margin-bottom: 22px;
        }
        ._span {
          font-size: 13px;
          font-weight: 400;
          line-height: 18PX;
        }
      }
      .icon {
        width: 8px;
        height: 6px;
        margin-right: 10px;
        margin-bottom: 2px;
        display: inline-block;
        border: 1px solid #4b84ff;
        border-width: 0 0 2px 2px;
        transform: rotate(-45deg);
        -ms-transform: rotate(-45deg);
        -moz-transform: rotate(-45deg);
        -webkit-transform: rotate(-45deg);
        -o-transform: rotate(-45deg);
        vertical-align: baseline;
      }
    }
    h1 {
      font-size: 15PX;
      font-weight: 500;
      color: #2f354d;
      line-height: 22px;
      margin-top: 20px;
    }
  }
}
.classpop {
  width: 200px !important;
}
.poplist {
  width: 140px;
  padding-top: 22px;
  background: #fff;
  font-size: 13px;
  font-weight: 400;
  color: #2f354d;
  line-height: 18PX;
  .isPopclass {
    color: #4b84ff;
    &::before {
      content: "";
      width: 8px;
      height: 6px;
      margin-right: 10px;
      margin-bottom: 2px;
      display: inline-block;
      border: 1px solid #4b84ff;
      border-width: 0 0 2px 2px;
      transform: rotate(-45deg);
      -ms-transform: rotate(-45deg);
      -moz-transform: rotate(-45deg);
      -webkit-transform: rotate(-45deg);
      -o-transform: rotate(-45deg);
      vertical-align: baseline;
    }
  }
  p {
    margin-bottom: 22px;
    padding-left: 24px;
    position: relative;
  }
}
.screen {
  display: flex;
  justify-content: space-between;
  height: 40px;
  line-height: 40px;

  .activeClass {
    color: #4b84ff;
    span {
      color: #4b84ff;
      transform: scale(0.8) rotate(180deg);
      vertical-align: top;
    }
  }
  p {
    font-size: 13px;
    font-family: @family;
    font-weight: 500;
    color: #2f354d;
    span {
      color: #2f354d;
      font-size: 9px;
      transform: scale(0.8);
      display: inline-block;
      margin-left: 4px;
      vertical-align: top;
    }
  }
}
</style>
